import type { ReactNode } from 'react';
import { Group, Text } from '@mantine/core';

interface DetailFieldProps {
  label: string;
  value?: ReactNode;
  multiline?: boolean;
}

export function DetailField({ label, value, multiline }: DetailFieldProps) {
  return (
    <Group align={multiline ? 'flex-start' : 'center'} gap="sm" wrap="nowrap">
      <Text size="sm" fw={500} w={140} style={{ flexShrink: 0 }}>
        {label}
      </Text>
      {value ? (
        typeof value === 'string' ? (
          <Text size="sm" style={{ flex: 1 }}>
            {value}
          </Text>
        ) : (
          <div style={{ flex: 1 }}>{value}</div>
        )
      ) : (
        <Text size="sm" c="dimmed" fs="italic">
          —
        </Text>
      )}
    </Group>
  );
}
